import script from "./DeckListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeckListView.vue?vue&type=script&lang=ts&setup=true"

import "./DeckListView.vue?vue&type=style&index=0&id=2a60a3ae&lang=scss"

const __exports__ = script;

export default __exports__